import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserRelationshipCacheKey, customObjectsLinkedToUserCacheKey } from "./constants";
import type { DeleteCustomObjectsUserRelationshipParams } from "./types";

export const deleteCustomObjectsUserRelationship = reactQueryMutationAdapter(
  [customObjectsUserRelationshipCacheKey, customObjectsLinkedToUserCacheKey],
  ({ typeName, externalId, userId, relId }: DeleteCustomObjectsUserRelationshipParams): Promise<void> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/users/${encodeURIComponent(userId)}`,
      "DELETE",
      { rel_id: relId },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
